import React from 'react';
import PropTypes from 'prop-types';
import { getStatusColor } from '../../../contracting/contractingUtils';

const { array, bool, node, object } = PropTypes;

const Stats = ({ classes, data }) => {
  return (<div style={{ display: 'flex', flexWrap: 'wrap' }}>
      {
        data
          .sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0))
          .map((d, i) =>
          <div key={i} style={{ flex: '1 0 50%', padding: '8px', textAlign: 'center' }}>
            <span
              style={{
                display: 'block',
                fontSize: '28px',
                lineHeight: '40px',
                color: getStatusColor(d.label),
              }}
            >
              {d.value}
            </span>
            <span
              style={{
                display: 'block',
                fontSize: '14px',
                textTransform: 'capitalize',
                color: getStatusColor(d.label),
              }}
            >
              {d.label}
            </span>
          </div>)
      }
    </div>);
};

Stats.propTypes = {
  data: array,
  style: object,
};

export default Stats;



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/charts/contractActivityStats.jsx